import { useRef, useState, useEffect } from 'react';
import { useIO } from '../hooks/use-io';
import { PAGE_TRANSITION_DELAY } from '../lib/constants';

export const useVisibleDelay = (delay = PAGE_TRANSITION_DELAY) => {
  const ref = useRef();
  const entry = useIO(ref, true);
  const isVisible = !!entry?.isIntersecting;
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => {
        setShouldAnimate(true);
      }, delay);
    }
  }, [isVisible]);

  return [ref, shouldAnimate];
};
